import DelegatePending from "./Pending";
import DelegateApproved from "./Approved";
import DelegationDashboard from "./Dashboard";
export default [
    { path: "/delegation/dashboard", component: DelegationDashboard },
    { path: "/delegation/pending", component: DelegatePending },
    { path: "/delegation/approved", component: DelegateApproved }
];
